import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_SCHEDULE_MANUFACTURING_DATES: createSagaAction('GET_SCHEDULE_MANUFACTURING_DATES'),
  ADD_SCHEDULE_MANUFACTURING_DATE: createSagaAction('ADD_SCHEDULE_MANUFACTURING_DATE'),
  DELETE_SCHEDULE_MANUFACTURING: createSagaAction('DELETE_SCHEDULE_MANUFACTURING'),
  SCHEDULE_MANUFACTURING_UPDATE: createSagaAction('SCHEDULE_MANUFACTURING_UPDATE'),
  SCHEDULE_MANUFACTURING_UPDATE_NOTE: createSagaAction('SCHEDULE_MANUFACTURING_UPDATE_NOTE')
}

// Action Creators
export const actions = {
  getScheduleManufacturingDates: ({ jobId }) => ({
    type: constants.GET_SCHEDULE_MANUFACTURING_DATES.ACTION,
    jobId
  }),

  addScheduleManufacturingDate: ({ jobId, userId, scheduleId }) => ({
    type: constants.ADD_SCHEDULE_MANUFACTURING_DATE.ACTION,
    jobId,
    userId,
    scheduleId
  }),

  deleteScheduleManufacturing: ({ jobId, scheduleId }) => ({
    type: constants.DELETE_SCHEDULE_MANUFACTURING.ACTION,
    jobId,
    scheduleId
  }),

  updateManufacturingDates: ({
    jobId,
    userId,
    scheduleId,
    scheduleType,
    description,
    content
  }) => ({
    type: constants.SCHEDULE_MANUFACTURING_UPDATE.ACTION,
    jobId,
    scheduleId,
    userId,
    scheduleType,
    description,
    content
  }),

  updateNotes: ({ jobId, userId, notes }) => ({
    type: constants.SCHEDULE_MANUFACTURING_UPDATE_NOTE.ACTION,
    jobId,
    userId,
    notes
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_SCHEDULE_MANUFACTURING_DATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_SCHEDULE_MANUFACTURING_DATES.SUCCESS:
      return {
        ...state,
        scheduleManufacturingDates: action.payload
      }
    case constants.GET_SCHEDULE_MANUFACTURING_DATES.FAILED:
      return {
        error: action.message
      }
    case constants.SCHEDULE_MANUFACTURING_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_SCHEDULE_MANUFACTURING.SUCCESS:
      return {
        ...state
      }
    case constants.ADD_SCHEDULE_MANUFACTURING_DATE.SUCCESS:
      return {
        ...state
      }
    case constants.SCHEDULE_MANUFACTURING_UPDATE_NOTE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/scheduleManufacturingActions.js